export enum ImportExportPaths {
  IMPORT = '/import',
  EXPORT = '/export'
}
